import React, { useEffect } from 'react';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import classNames from 'classnames';

const Counter = React.forwardRef(function Counter({ gameTimer, setGameTimer, mod, state, setState }, ref) {
  useEffect(() => {
    if (state !== 'countdown') return;

    if (gameTimer - 1 < 0 && state === 'countdown') {
      setState('playing');
      return;
    }

    const t = setTimeout(() => setGameTimer(gameTimer - 1), 700);
    return () => clearTimeout(t);
  }, [state, setState, gameTimer, setGameTimer]);

  return (
    <>
      <TransitionGroup component={null}>
        {state === 'countdown' && !!gameTimer && (
          <CSSTransition key={gameTimer} timeout={{ enter: 400, exit: 400 }} classNames={'counter'}>
            <div className={classNames('counter', { ['counter_' + mod]: mod })}>
              <div className={'counter__text'}>{gameTimer}</div>
            </div>
          </CSSTransition>
        )}
      </TransitionGroup>
    </>
  );
});
export default Counter;
Counter.propTypes = {};
